import { Skeleton } from "@material-ui/lab";

export default function LoadingCard() {
  return (
    <Skeleton
      variant="rect"
      height="118px"
      width="280px"
      style={{ borderRadius: "4px" }}
    />
  );
}
